import Vue from 'vue'
import OneSignalVue from 'onesignal-vue'

Vue.use(OneSignalVue)

export default ({ app }, inject) => {
  inject('swNotification', {
    oneSignalStates: [],
    messages: [],
    permission: null,

    init() {
      console.log('init oneSignal... ⏳')
      this.oneSignalStates.push({ date: new Date(), state: 'init' })

      const OneSignal = typeof window !== 'undefined' ? window.OneSignal : null

      if (!OneSignal) {
        console.warn('OneSignal not found')
        return
      }

      OneSignal.init({
        appId: process.env.NODE_ENV === 'production' ? '42bfde9d-a2ba-4724-83d5-aab17e3b4e50' : '14cdb49f-65ad-427c-bf58-2dcdd458fd02',
        safari_web_id:
          process.env.NODE_ENV === 'production'
            ? 'web.onesignal.auto.5d6ab6d2-4d0b-4ad8-b336-7f8ff3aff850'
            : 'web.onesignal.auto.44fa898b-ecac-43e4-a4f9-b7817452e5d5',
        allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production'
        // notifyButton: {        //   enable: true        // },
      })
        .then(() => {
          this.oneSignalStates.push({ date: new Date(), state: 'OneSignal initialized' })

          console.log('✅  OneSignal initialized')
        })
        .catch(err => {
          this.oneSignalStates.push({ date: new Date(), state: 'OneSignal initialization failed' })
          console.log('❌  OneSignal initialization failed', err)
        })

      OneSignal.Notifications.addEventListener('click', notification => {
        console.log('click OneSignal notification', notification)
      })

      OneSignal.Notifications.addEventListener('change', notification => {
        console.log('change OneSignal permissions', OneSignal.Notifications.permission)
        this.permission = OneSignal.Notifications.permission

        if (notification.current?.id) {
          console.log('Onesignal user logged-in', OneSignal.User.externalId)
        }
      })

      OneSignal.Notifications.addEventListener('foregroundWillDisplay', notification => {
        this.oneSignalStates.push({ date: new Date(), state: 'OneSignal foregroundWillDisplay notification arrived' })
        const message = `${notification.notification.title}: ${notification.notification.body}`
        this.oneSignalStates.push({ date: new Date(), state: message })
        this.messages.push(message)
        console.log('✅ OneSignal foregroundWillDisplay notification arrived', message)
      })
    },
    async subscribe(id, email) {
      const OneSignal = typeof window !== 'undefined' ? window.OneSignal : null
      if (!OneSignal) return

      if (!OneSignal.Notifications.permission || !OneSignal.User.PushSubscription.optedIn) {
        console.log('subscribing ...')
        this.oneSignalStates.push({ date: new Date(), state: 'subscribing' })
        await this.login(id, email)

        if (!OneSignal.User.PushSubscription.optedIn) {
          this.oneSignalStates.push({ date: new Date(), state: 'opting in' })
          OneSignal.User.PushSubscription.optIn()
        }

        setTimeout(() => {
          console.log('OneSignal prompt')
          OneSignal.Slidedown.promptPush()
        }, 500)
      } else {
        console.log('Logout, elimina el permiso')
        this.logout()
      }
    },
    async login(id, email) {
      const OneSignal = typeof window !== 'undefined' ? window.OneSignal : null
      if (!OneSignal) return

      await OneSignal.login(id)
      OneSignal.User.addTags({ app: 'facturacion', email })
      this.oneSignalStates.push({ date: new Date(), state: 'login' })
    },
    logout() {
      const OneSignal = typeof window !== 'undefined' ? window.OneSignal : null
      if (!OneSignal) return

      this.oneSignalStates.push({ date: new Date(), state: 'opt-out' })
      OneSignal.User.PushSubscription.optOut()
    }
  })
}
